import {Button, Column, Text, Row} from "react-vcomponents";
import {BaseComponent} from "react-vextensions";
import {ScrollView} from "react-vscrollview";
import {Observer} from "web-vcore";
import React from "react";
import {GetLiveLocalSession_Reactive} from "../../../Engine/LiveSessionManagement.js";
import {AddJournalEntry} from "../../../Server/Commands/JournalEntryCommands.js";
import {JournalEntry} from "../../../Server/DB/journalEntries/@JournalEntry.js";
import {store} from "../../../Store/index.js";
import {JournalEntryPreview} from "../../Journal/JournalEntryPreview.js";
import {observer_mgl} from "mobx-graphlink";
import {Journey_GetSessionPeriodsToShow} from "../../../Server/DB/journalEntries.js";
import {SessionPeriod} from "../../../Server/DB/@Shared/SessionPeriod.js";
import moment from "moment";

export const SessionPeriodsUI = observer_mgl(()=>{
	const uiState = store.main.engine.journey;
	const liveLocalSession = GetLiveLocalSession_Reactive();

	const {journalEntryForLiveSession, sessionPeriodsToShow} = Journey_GetSessionPeriodsToShow();

	return (
		<ScrollView style={{flex: 60}} contentStyle={{display: "flex", flexDirection: "column"}}>
			{sessionPeriodsToShow.map(period=>{
				const key = `${period.startTime}_${period.sessions?.map(a=>a.id).Join("_") ?? ""}`; // add session-ids to key (clash is observed otherwise, in some cases)
				if (period.journalEntries.length > 0) {
					return (
						<React.Fragment key={key}>
							{period.journalEntries.map(entry=>{
								return <JournalEntryPreview key={entry.id} entry={entry} journalPage={false}/>;
							})}
						</React.Fragment>
					);
				}
				return <DaySessionPreview key={key} period={period}/>;
			})}
			{liveLocalSession != null && journalEntryForLiveSession == null &&
			<Row mt={30} mb={30} style={{justifyContent: "center"}}>
				<Button text="Add journal entry for live session" enabled={liveLocalSession != null} onClick={async()=>{
					const entry = new JournalEntry({
						title: "New entry",
						sleepTime: liveLocalSession.coreData.startTime,
						segments: [],
					});
					const entryID = await new AddJournalEntry({entry}).RunOnServer();
				}}/>
			</Row>}
			{/* add spacer at bottom, for more control of scrolling */}
			<div style={{height: 300}}/>
		</ScrollView>
	);
});

const DaySessionPreview = observer_mgl((props: {period: SessionPeriod})=>{
	const {period} = props;
	return (
		<Column mt={30} pl={10} style={{position: "relative"}}>
			<Row>Standalone session. ({period.sessions[0].launchType})</Row>
			<Row>
				<Text>Start: {moment(period.startTime).format("YYYY-MM-DD HH:mm:ss")}</Text>
			</Row>
			{period.endTime &&
			<Row>
				<Text>End: {moment(period.endTime).format("YYYY-MM-DD HH:mm:ss")}</Text>
			</Row>}
		</Column>
	);
});